import { AronAuditTabPane } from "./AronAuditTabPane";
import { AronPaneDropOverlay } from "./AronPaneDropOverlay";
import { AronTabBar } from "./AronTabBar";
import { AronTabPane } from "./AronTabPane";
import {
  useAronWorkbenchStore,
  type AronGroupNode,
} from "../../store/aronWorkbenchStore";

/** One editor group: its tab strip plus every tab it holds (only the active one
 * is visible — the rest stay mounted and keep streaming). */
export function AronEditorGroup({
  group,
  isActiveGroup,
  groupCount,
  onPopOut,
  onDetach,
}: {
  group: AronGroupNode;
  isActiveGroup: boolean;
  groupCount: number;
  onPopOut: (convId: string) => void;
  onDetach: (convId: string) => void;
}) {
  const focusGroup = useAronWorkbenchStore((s) => s.focusGroup);
  const adoptConversation = useAronWorkbenchStore((s) => s.adoptConversation);

  return (
    <section
      onMouseDown={() => !isActiveGroup && focusGroup(group.id)}
      className={`flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden ${
        groupCount > 1 && isActiveGroup
          ? "ring-1 ring-inset ring-red-200 dark:ring-red-900/50"
          : ""
      }`}
    >
      <AronTabBar
        group={group}
        isActiveGroup={isActiveGroup}
        groupCount={groupCount}
        onPopOut={onPopOut}
        onDetach={onDetach}
      />
      <div className="relative flex min-h-0 flex-1 flex-col bg-white dark:bg-gray-900">
        <AronPaneDropOverlay groupId={group.id} />
        {group.tabs.map((t) =>
          // Podgląd cudzej rozmowy (audyt) nie jest czatem — inny panel, bez
          // komponowania odpowiedzi i bez endpointów właściciela wątku.
          t.readOnly && t.convId ? (
            <AronAuditTabPane
              key={t.key}
              convId={t.convId}
              active={group.activeKey === t.key}
            />
          ) : (
            <AronTabPane
              key={t.key}
              convId={t.convId}
              active={group.activeKey === t.key}
              onCreated={(convId) => adoptConversation(group.id, t.key, convId)}
            />
          ),
        )}
      </div>
    </section>
  );
}
